import { CategoryGrid } from '@common/components/CategoryGrid';
import { Heading4 } from '@common/components/Typography';
import { Category } from 'shared-types/Common';
import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { CategoriesWrapper, NotFound } from './Categories.styles';

type CategoriesProps = {
  categories: Category[];
};

export const Categories: FC<CategoriesProps> = ({ categories }) => {
  const { t } = useTranslations();

  return (
    <CategoriesWrapper>
      <Heading4 tag="h1">{t('categoriesListing.browseByCategories')}</Heading4>
      <CategoryGrid categories={categories} />
      {categories && !categories.length && (
        <NotFound>
          <h1>{t('app.noCategoriesFound')}</h1>
        </NotFound>
      )}
    </CategoriesWrapper>
  );
};
